import { render, staticRenderFns } from "./AdminSettingsSignUpStrategy.vue?vue&type=template&id=3e5be3c6&scoped=true&"
import script from "./AdminSettingsSignUpStrategy.vue?vue&type=script&lang=ts&"
export * from "./AdminSettingsSignUpStrategy.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=3e5be3c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5be3c6",
  null
  
)

export default component.exports